import React from 'react';
import { Plus } from 'lucide-react';
import { useEmployees } from './hooks/useEmployees';
import { EmployeesTable, EmployeeModal } from './components';
import { EmployeesFilters } from './components/EmployeesFilters';
import { Button } from '@/components/ui/button';

export const EmployeesPage: React.FC = () => {
  const { 
    employees,
    positions,
    locations,
    stats, 
    filters,
    loading, 
    error,
    isCreateModalOpen,
    isEditModalOpen,
    selectedEmployee,
    updateFilters,
    createEmployee,
    updateEmployee,
    toggleEmployeeStatus,
    openCreateModal,
    closeCreateModal,
    openEditModal,
    closeEditModal
  } = useEmployees();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-macartur-primary mx-auto mb-4"></div>
          <p className="text-gray-600">Cargando empleados...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="text-red-600 mb-4">
            <svg className="h-12 w-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <p className="text-red-600">{error}</p>
        </div>
      </div>
    );
  }


  const handleEditEmployee = (employee: any) => {
    openEditModal(employee);
  };


  const handleToggleStatus = async (employeeId: string, newStatus: any) => {
    await toggleEmployeeStatus(employeeId, newStatus);
  };

  return (
    <div className="p-3 md:p-6 space-y-4 md:space-y-6 h-full overflow-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div>
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Gestión de Empleados</h1>
          <p className="text-gray-600 mt-1 text-sm md:text-base">
            Administra la información y permisos de tu equipo de trabajo
          </p>
        </div>
        <Button
          onClick={openCreateModal}
          className="flex items-center gap-2 bg-macartur-primary hover:bg-macartur-primary/90"
        >
          <Plus className="w-4 h-4" />
          <span className="hidden sm:inline">Nuevo Empleado</span>
        </Button>
      </div>


      {/* Filters */}
      <EmployeesFilters 
        filters={filters}
        onFiltersChange={updateFilters}
      />

      {/* Employees Table */}
      <div className="bg-white rounded-lg border">
        <EmployeesTable
          employees={employees}
          onEdit={handleEditEmployee}
          onToggleStatus={handleToggleStatus}
        />
      </div>

      {/* Create/Edit Modal */}
      <EmployeeModal
        isOpen={isCreateModalOpen || isEditModalOpen}
        onClose={isCreateModalOpen ? closeCreateModal : closeEditModal}
        onCreate={createEmployee}
        onUpdate={updateEmployee}
        positions={positions}
        locations={locations}
        employee={selectedEmployee}
        loading={loading}
      />
    </div>
  );
};